import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Pipe({
  name: 'isFormRequired',
  standalone: true,
})
export class IsFormRequiredPipe implements PipeTransform {
  transform(value: FormGroup | FormControl, ...args: unknown[]): boolean {
    if (value) return value.hasValidator(Validators.required);
    return false;
  }
}

@Pipe({
  name: 'createRequiredString',
  standalone: true,
})
export class CreateRequiredStringPipe implements PipeTransform {
  transform(value: FormGroup | FormControl, ...args: unknown[]): string {
    if (value) return value.hasValidator(Validators.required) ? '*' : '';
    return '';
  }
}
